import React, { ComponentProps } from "react";

export default function ChevronDownIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="8"
      viewBox="0 0 13 8"
      {...props}
    >
      <path
        d="M6.7872 7.3833C7.01491 7.38084 7.21111 7.29581 7.38468 7.11558L12.4943 1.89997C12.6407 1.7481 12.7142 1.56703 12.7142 1.34833C12.7142 0.917613 12.3759 0.571411 11.9409 0.571411C11.7289 0.571411 11.5327 0.65766 11.3803 0.806989L6.78846 5.51566L2.19412 0.806988C2.04292 0.658865 1.85103 0.571411 1.63229 0.571411C1.19852 0.571411 0.859032 0.917613 0.859032 1.34832C0.859032 1.56462 0.932518 1.7481 1.0844 1.89997L6.18978 7.11558C6.36886 7.29701 6.56075 7.3833 6.7872 7.3833Z"
        fill={props.fill || "white"}
      />
    </svg>
  );
}
